import React, { useState, useEffect } from "react";
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import AsciiPage from "./components/AsciiPage";
import ProjectsPage from "./components/ProjectsPageV2";
import SentientStudiosPage from "./components/projects/SentientStudiosPage";
import SpaceBluesPage from "./components/projects/SpaceBluesPage";
import ExitDeathRecordsPage from "./components/projects/ExitDeathRecordsPage";
import ExitDeathVisionPage from "./components/ExitDeathVisionPage";
import DesignsPage from "./components/DesignsPage";
import ComingSoonPage from "./components/ComingSoonPage";
import DailyTrainingPage from "./components/mindUpdate/DailyTrainingPage";
import iterationBodyLabs from "./sites/iteration-body-labs/routes";
import mecharts from "./sites/mecharts/routes";

function App() {
    const [isAsciiComplete, setAsciiComplete] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setAsciiComplete(true);
        }, 5000);
    }, []);

    return (
        <Router>
            <Analytics />
            <Routes>
                <Route
                    path="/"
                    element={
                        isAsciiComplete ? (
                            <Navigate to="/projects" state={{ fromRoot: true }} />
                        ) : (
                            <AsciiPage />
                        )
                    }
                />

                {/* Projects landing page */}
                <Route path="/projects" element={<ProjectsPage />} />

                {/* Project detail pages */}
                <Route path="/projects/sentient-studios" element={<SentientStudiosPage />} />
                <Route path="/projects/space-blues" element={<SpaceBluesPage />} />
                <Route path="/projects/exit-death-records" element={<ExitDeathRecordsPage />} />
                <Route path="/vision" element={<ExitDeathVisionPage />} />
                <Route path="/designs" element={<DesignsPage />} />
                <Route path="/coming-soon" element={<ComingSoonPage />} />
                <Route path="/daily-updates" element={<DailyTrainingPage />} />

                {/* Standalone sub-sites: each owns its layout, styles and content under src/sites/<name>/ */}
                {iterationBodyLabs}
                {mecharts}

                {/* Catch-all route */}
                <Route path="*" element={<Navigate to="/projects" />} />
            </Routes>
        </Router>
    );
}

export default App;
